<template>
  <b-col class="p-4 p-md-5" data-cy="profissionais-container">
    <div class="d-flex flex-column" data-cy="profissionais-header">
      <h4 class="text-primary font-weight-bold" data-cy="profissionais-title">
        Profissional
      </h4>
      <small class="font-weight-bold" data-cy="profissionais-subtitle"
        >Busque ou selecione o profissional de sua preferência</small
      >
    </div>
    <search-filter
      placeholder="Buscar Profissional..."
      data-cy="profissionais-search-filter"
    ></search-filter>

    <div
      class="d-flex flex-column"
      style="color: orange;"
      data-cy="profissionais-error-list-container"
    >
      <ul
        v-for="error in errors"
        :key="error"
        :data-cy="`profissionais-error-${error}`"
      >
        <li data-cy="profissionais-error-item">{{ error }}</li>
      </ul>
    </div>

    <div
      class="text-primary text-uppercase"
      data-cy="profissionais-list-container"
    >
      <div
        :class="
          `custom-radio-wrapper mb-2 ${
            medic_s && medic_s.id === medic.id ? 'border-primary' : ''
          }`
        "
        v-for="medic in medics"
        :key="medic.id"
        :data-cy="`profissionais-item-${medic.id}`"
      >
        <div
          class="custom-control custom-radio w-100"
          data-cy="profissionais-radio-wrapper"
        >
          <input
            type="radio"
            class="custom-control-input"
            :id="`medic-${medic.id}`"
            :value="medic"
            :checked="medic_s && medic_s.id === medic.id"
            @change="submit(medic)"
            :data-cy="`profissionais-radio-${medic.id}`"
          />
          <img
            style="position: absolute; right: 0"
            :src="`${$serverHost}agendamentos/profissionais/${medic.id}/foto`"
            width="50"
            height="50"
            alt
            :data-cy="`profissionais-img-${medic.id}`"
          />
          <label
            class="custom-control-label d-inline-flex flex-column"
            :for="`medic-${medic.id}`"
            :data-cy="`profissionais-label-${medic.id}`"
          >
            {{ medic.nome }}
            <span class="small" :data-cy="`profissionais-crm-${medic.id}`">
              CRM: {{ medic.id }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import SearchFilter from "@/components/filter.vue";

export default {
  name: "medic",
  components: {
    SearchFilter
  },
  data() {
    return {
      errors: []
    };
  },
  methods: {
    submit(medic) {
      medic.stepId = 5;
      this.$store.dispatch("load_selected", medic);
      this.$store.dispatch("set_to", {
        name: "consulta_paciente",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.$route.query.clinica,
          horario: this.$route.query.horario,
          medico: medic.id
        }
      });
    }
  },
  computed: {
    medics() {
      return this.$store.getters.medics;
    },
    medic_s() {
      return this.$store.getters.get_selected[4];
    }
  },
  mounted() {
    let payload = {
      organizationId: this.$route.params.organizationId,
      url: `${this.$serverHost}agendamentos/profissionais`
    };

    this.$store.dispatch("load_medics", payload).then(() => {
      if (this.medics.length === 1) {
        this.submit(this.medics[0]);
      }
    });

    this.$store.dispatch("set_actual", this.$route.fullPath);
    this.$store.dispatch("set_from", {
      name: "consulta_agendar",
      params: { organizationId: this.$route.params.organizationId },
      query: {
        convenio: this.$route.query.convenio,
        especialidade: this.$route.query.especialidade,
        clinica: this.$route.query.clinica
      }
    });

    if (this.medic_s.nome) {
      this.$store.dispatch("set_to", {
        name: "consulta_paciente",
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: this.$route.query.especialidade,
          clinica: this.$route.query.clinica,
          horario: this.$route.query.horario,
          medic: this.medic_s.id
        }
      });
    } else {
      this.$store.dispatch("set_to", "");
    }
  }
};
</script>

<style></style>
